import { render, staticRenderFns } from "./PopularPicks.vue?vue&type=template&id=dd978b84&scoped=true&"
import script from "./PopularPicks.vue?vue&type=script&lang=js&"
export * from "./PopularPicks.vue?vue&type=script&lang=js&"
import style0 from "./PopularPicks.vue?vue&type=style&index=0&id=dd978b84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd978b84",
  null
  
)

export default component.exports